<template>
  <el-drawer
    :visible="drawerVisible"
    :modal="false"
    :size="'240px'"
    :show-close="false"
    append-to-body
    id="fileDrawer"
  >
    <template #title>
      <div class="header_title">
        <span>发票缩略图预览</span>
        <i class="el-icon-close" @click="close"></i>
      </div>
    </template>
    <div class="drawer_content" >
      <div class="thumbnail_item" v-for="(item, index) in copyFiles" :key="index">
        <div class="img">
          <img :src="`${imgShow}${item.thumbnailUrl}`" alt=""  @click="openShow(index)"/>
          <div class="btn">
            <i class="el-icon-edit edit" @click="item.isEdit = true" v-show="!hideBtn"></i>
            <i
              class="el-icon-zoom-in scale"
              @click="openShow(index)"
            ></i>
            <i
              class="el-icon-delete del"
              v-show="!hideBtn"
              @click="$emit('delFile', item, index)"
            ></i>
          </div>
        </div>
        <div class="img_name" :title="item.fileName" v-if="!item.isEdit">{{ item.fileName }}</div>
        <div  v-else class="edit_name">
          <el-input size="mini" v-model="item.fileName" style="width:100%;" maxlength="200"></el-input>
          <div style="text-align:right;margin-top:10px;">
            <el-button type="info" size="mini" @click="cancelTask(item)">取消</el-button>
            <el-button type="primary" size="mini" @click="submitTask(item)" style="margin:0;">确定</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- <span>我来啦!</span> -->
    <previewPicture ref="previewPicture" :images="images" />
  </el-drawer>
  <!-- <div id="fileDrawer" v-if="drawerVisible">

  </div> -->
</template>

<script>
import previewPicture from "@/components/previewPicture";
import { imgShow } from "@/assets/js/apiConfig.js";
export default {
  components: {
    previewPicture,
  },
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    drawerVisible: {
      type: Boolean,
      default: false,
    },
    hideBtn:{
      type:Boolean,
      default:false
    },
  },
  watch:{
    files:{
      handler(v){
        this.copyFiles = JSON.parse(JSON.stringify(v)).map(x=>{
          x.isEdit = false
          x.oldName = x.fileName
          return x
        })
      },deep:true
    }
  },
  data() {
    return {
      copyFiles:[],
      images: [],
      imgShow,
    };
  },
  methods: {
    delTask(){

    },
    submitTask(item){
      item.isEdit = false
      item.oldName = item.fileName
      this.$emit('editTask',this.copyFiles)
    },
    cancelTask(item){
      item.isEdit = false
      item.fileName = item.oldName
    },
    openShow(index){
        this.images = this.files.map(e=>{
            return `${this.imgShow}${e.imgUrl}`
        })
        this.$refs.previewPicture.show(index)
    },
    close() {
      this.copyFiles = this.copyFiles.map(x=>{
        x.isEdit = false
        return x
      })
      this.$emit("update:drawerVisible", false);
    },
  },
};
</script>
<style lang="less" >
  #fileDrawer {
 width: 240px !important;
  height: 100vh !important;
  bottom: auto !important;
  left: auto !important;
  }
</style>
<style lang="less" scoped>
//  .fileDrawer{
//   width: 240px;
//   height: 100vh;
// }
.edit_name {
  // display: flex;
  margin: 10px 0;
}
.thumbnail_item {
  width: 100%;
  display: inline-block;
  margin-top: 20px;
  box-sizing: border-box;
  .img {
    position: relative;
    width: 100%;
    height: 154px;
    border-radius: 4px;
    // background: #fff;
    cursor: pointer;
    border: 1px solid transparent;
    .btn {
      display: none;
      justify-content: flex-end;
      column-gap: 10px;
      padding: 10px;
      box-sizing: border-box;
      position: absolute;
      // display: flex;
      align-items: center;
      bottom: 0;
      width: 100%;
      height: 27px;
      background: rgba(0, 0, 0, 0.6);
      .scale,.edit {
        color: #fff;
      }
      .del {
        color: #ff6010;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
    &:hover {
      border: 1px solid #269d7b;
      .btn {
        display: flex;
      }
    }
  }
  .img_name {
    margin-top: 10px;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.drawer_content {
  //   display: inline-block;
  width: 100%;
  height: auto;
  background: #e6e8ea !important;

  padding: 0 6px;
  box-sizing: border-box;
  border-radius: 0 !important;
}
/deep/ .el-drawer,
.rtl {
  top: 78px !important;
  height: calc(100vh - 78px) !important;
  // height: calc(100% - 78px);
  border-radius: 4px !important;
}
/deep/ .el-drawer__header {
  font-size: 14px;
  padding: 10px 8px;
  box-sizing: border-box;
  margin: 0;
  color: #333;
  font-weight: bold;
}
.header_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-icon-close {
    cursor: pointer;
    color: #000;
    font-weight: bold;
  }
}
// #fileDrawer {
//   width: 240px;
//   position: fixed;
//   right: 0;
//   top: 78px;
//   height: calc(100vh - 78px);
//   border-radius: 4px;
//   background: #e6e8ea;
// }
</style>


// WEBPACK FOOTER //
// src/components/drawer/FileDrawer.vue